<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="0"
      :BackPath="'/A01'"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      :Type="false"
      :ImgUrl="'A01.png'"
      :ImgUrls="'A02.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container.vue";
export default {
  name: "A0104",
  data() {
    return {
      Bignav: false,
      Container: {
        subtitle: "",
        videosrc: "A0104.mp4",
        title: "實現個人化照護",
        list: [
          {
            body:
              "每1.8秒，世界上就有人聽到這樣的診斷：「癌症」，但接下來發生的事，從不按劇本演出。因為沒有兩個患者是相同的，也沒有兩種癌症會以相同的方式發展。正因如此，我們堅信個人化照護必須貫穿患者的整個治療歷程。"
          },
          {
            body:
              "精準鎖定腫瘤的治療方案，同時保護患者，個人化照護有助於確保治療方案能反映每位患者對治療的反應。"
          },
          {
            body: "個人化是提供可靠照護的關鍵，且是保護患者的核心。"
          }
        ]
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
